export const utcDayKey = (date: Date): string => {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

/** Calendar day shown on a date picker, stored as a UTC day. */
export const pickerDateToUtcKey = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const utcKeyToPickerDate = (value: string): Date => {
  const [
    year,
    month,
    day
  ] = value.slice(0, 10).split("-").map(Number);

  return new Date(year, month - 1, day);
};

/** UTC calendar day of the session start, matching the value stored on the session. */
export const sessionUtcDayKey = (date: Date, startTime: Date): string => {
  const combined = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    startTime.getHours(),
    startTime.getMinutes(),
    0,
    0
  );

  return utcDayKey(combined);
};

export const eachUtcDayKey = (startKey: string, endKey: string): string[] => {
  const keys: string[] = [];
  let cursor = Date.parse(`${startKey}T00:00:00.000Z`);
  const end = Date.parse(`${endKey}T00:00:00.000Z`);

  for (; cursor <= end; cursor += 86400000) {
    keys.push(utcDayKey(new Date(cursor)));
  }

  return keys;
};

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export const formatUtcDate = (value: string): string => {
  const [
    year,
    month,
    day
  ] = value.slice(0, 10).split("-").map(Number);

  return `${day} ${MONTHS[ month - 1 ]} ${year}`;
};

export const missionDayNumber = (startKey: string, dayKey: string): number => {
  const start = Date.parse(`${startKey}T00:00:00.000Z`);
  const day = Date.parse(`${dayKey}T00:00:00.000Z`);

  return Math.round((day - start) / 86400000) + 1;
};

/** Day 1 is the mission start date. Before that, show the start date. */
export const missionDayLabel = (startDate: string): string => {
  const startKey = startDate.slice(0, 10);
  const now = new Date();
  const today = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
  const start = Date.parse(`${startKey}T00:00:00.000Z`);
  const day = Math.round((today - start) / 86400000) + 1;

  if (day < 1) {
    return formatUtcDate(startKey);
  }

  return `Day ${day}`;
};
